import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { CheckCircleIcon, XCircleIcon, ArrowRightIcon } from "@heroicons/react/16/solid"

export const PaymentResultPage = () => {
  const [searchParams] = useSearchParams()
  const status = searchParams.get("status") === "failure" ? "failure" : "success"
  const orderId = searchParams.get("order_id") || ""
  const isSuccess = status === "success"

  const deepLink = `vkonekte://payment/result?status=${status}&order_id=${orderId}`

  const [secondsLeft, setSecondsLeft] = useState(3)

  useEffect(() => {
    window.location.href = deepLink
  }, [deepLink])

  useEffect(() => {
    if (secondsLeft <= 0) return
    const t = setTimeout(() => setSecondsLeft((s) => s - 1), 1000)
    return () => clearTimeout(t)
  }, [secondsLeft])

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-50/70 via-white to-white px-4 py-10 text-gray-900">
      <div className="w-full max-w-sm">
        <div className="bg-white rounded-2xl border border-gray-100 shadow-xl p-8 text-center">
          <img src="/horizontal-1.png" alt="Vkonekte" className="h-9 w-auto mx-auto mb-6" />

          <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4 ${isSuccess ? "bg-emerald-50" : "bg-rose-50"}`}>
            {isSuccess ? (
              <CheckCircleIcon className="w-7 h-7 text-emerald-500" />
            ) : (
              <XCircleIcon className="w-7 h-7 text-rose-500" />
            )}
          </div>

          <h1 className="text-xl font-bold text-gray-900 mb-2">
            {isSuccess ? "Оплата прошла успешно" : "Оплата не прошла"}
          </h1>
          <p className="text-sm text-gray-500 leading-relaxed">
            {isSuccess
              ? "Спасибо! Возвращаем вас в приложение Vkonekte."
              : "Платёж не был завершён. Попробуйте повторить оплату в приложении Vkonekte."}
          </p>

          {orderId && (
            <div className="inline-flex items-center gap-2 bg-gray-50 border border-gray-100 rounded-full px-3.5 py-1.5 mt-4">
              <span className="text-[11px] font-semibold uppercase tracking-wider text-gray-400">Заказ</span>
              <span className="text-xs font-mono text-gray-600">{orderId}</span>
            </div>
          )}

          <a
            href={deepLink}
            className="w-full inline-flex items-center justify-center gap-1.5 mt-6 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-5 py-2.5 rounded-xl transition-colors shadow-sm shadow-blue-200"
          >
            Вернуться в приложение
            <ArrowRightIcon className="w-3.5 h-3.5" />
          </a>

          <p className="text-xs text-gray-400 mt-4">
            {secondsLeft > 0
              ? `Автоматический переход через ${secondsLeft} с...`
              : "Если приложение не открылось, нажмите на кнопку выше."}
          </p>
        </div>

        <p className="text-center text-xs text-gray-400 mt-6">
          © {new Date().getFullYear()} Vkonekte. Все права защищены.
        </p>
      </div>
    </div>
  )
}
